import styled from 'styled-components';

export const Wrapper = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;

  width: 250px;

  padding: 10px;
  border-radius: 15px;

  background: yellow;

  cursor: pointer;
`;
